/*
 * ===============================================================================================================
 *                                Copyright 2023, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => ({
  content: {
    display: 'flex'
  },
  chip: {
    margin: theme.spacing(-0.5, 0, 0, 1),
    background: 'white'
  },
  listItem: {
    display: 'flex',
    alignItems: 'center'
  }
}));
